import { createSelector } from "reselect"
import { initialState } from "./reducer"

const selectActionPlansImportSummary = (state) =>
  state.get("actionPlansImportSummary", initialState)

export const makeSelectSummary = () =>
  createSelector(selectActionPlansImportSummary, (state) =>
    state.get("summary")
  )

export const makeSelectIsLoadingSummary = () =>
  createSelector(selectActionPlansImportSummary, (state) =>
    state.get("isLoadingSummary")
  )

export const makeSelectPercentage = () =>
  createSelector(selectActionPlansImportSummary, (state) =>
    state.get("percentage")
  )

const makeSelectActionPlansImportSummary = () =>
  createSelector(selectActionPlansImportSummary, (substate) => substate.toJS())

export default makeSelectActionPlansImportSummary
export { selectActionPlansImportSummary }
